import { Link, useLocation, useNavigate } from "react-router-dom";
import GibletChat from "@/components/GibletChat";
import { ShoppingCart, Store, ArrowLeft } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isMarketplace = location.pathname === "/marketplace";
  const isLandingPage = location.pathname === "/platform-select";
  const isIndex = location.pathname === "/";
  const isIntroPage = location.pathname === "/intro";
  const handleBackClick = () => {
    if (isIndex) {
      navigate("/platform-select");
    } else {
      navigate(-1);
    }
  };

  // Simplified navbar for intro page
  if (isIntroPage) {
    return <nav className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <Link to="/home">
                <img src="/lovable-uploads/cff3231d-8a8c-4f5b-9340-bc437fa8da36.png" alt="iSPAI" className="h-8 cursor-pointer hover:opacity-80 transition-opacity" />
              </Link>
            </div>
            <div className="flex items-center">
              <h1 className="font-bold text-xl">Integrated Special Purpose AI (iSPAI)</h1>
            </div>
          </div>
        </div>
      </nav>;
  }

  // Standard navbar for other pages
  return <nav className="bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <button onClick={handleBackClick} className="mr-4 p-2 hover:bg-gray-100 rounded-full transition-colors" aria-label="Go back">
              <ArrowLeft className="h-5 w-5" />
            </button>
            <Link to="/" className="flex items-center">
              <img src="/lovable-uploads/cff3231d-8a8c-4f5b-9340-bc437fa8da36.png" alt="iSPAI" className="h-8" />
            </Link>
          </div>
          <div className="flex items-center justify-center flex-1">
            <GibletChat />
          </div>
          <div className="flex items-center space-x-4">
            <Tooltip>
              <TooltipTrigger asChild>
                <Link to="/giblet" className="text-black hover:text-black/80 transition-colors" aria-label="Giblet">
                  <img src="/lovable-uploads/2f8d2347-5a52-4e44-94a5-7cac5bdc2143.png" alt="Giblet" className="h-12 w-12 transform transition-transform duration-200 hover:scale-[2.0]" />
                </Link>
              </TooltipTrigger>
              <TooltipContent>Giblet</TooltipContent>
            </Tooltip>
            <Tooltip>
              <TooltipTrigger asChild>
                <Link to="/trey-profile" className="text-black hover:text-black/80 transition-colors" aria-label="My Profile">
                  <Avatar className="h-8 w-8 transform transition-transform duration-200 hover:scale-[1.5]">
                    <AvatarImage src="/lovable-uploads/1cf9a1ab-1e59-4c47-843a-e51f728830b6.png" alt="Profile" />
                    <AvatarFallback>AI</AvatarFallback>
                  </Avatar>
                </Link>
              </TooltipTrigger>
              <TooltipContent>mySPAI_Trey</TooltipContent>
            </Tooltip>
          </div>
        </div>
      </div>
    </nav>;
};
export default Navbar;